module.exports = __webpack_public_path__ + "static/media/img--mobile.7fc9057b.webp";